import { createContext, useContext } from "react";
const FormRenderContext = createContext(null);
export function useFormRenderContext() {
    const ctx = useContext(FormRenderContext);
    if (!ctx) {
        return {};
    }
    return ctx;
}
export { FormRenderContext };
